import { render, staticRenderFns } from "./AddBlackDialog.vue?vue&type=template&id=a6bfc2aa&scoped=true&"
import script from "./AddBlackDialog.vue?vue&type=script&lang=js&"
export * from "./AddBlackDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddBlackDialog.vue?vue&type=style&index=0&id=a6bfc2aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bfc2aa",
  null
  
)

export default component.exports